var map = {
	"./assets/imgs/overview/banner-cn.png": 16202,
	"./assets/imgs/overview/banner-en.png": 8910,
	"./assets/imgs/overview/composition-cn.png": 62855,
	"./assets/imgs/overview/composition-en.png": 2814,
	"./assets/imgs/overview/disclosure-cn.png": 95938,
	"./assets/imgs/overview/disclosure-en.png": 70392,
	"./assets/imgs/overview/footer-bg.png": 42697,
	"./assets/imgs/overview/formula-cn.png": 14387,
	"./assets/imgs/overview/formula-en.png": 81271,
	"./assets/imgs/overview/monitor-cn.png": 42129,
	"./assets/imgs/overview/monitor-en.png": 54057,
	"./assets/imgs/overview/novelty-cn.png": 77776,
	"./assets/imgs/overview/novelty-en.png": 72006,
	"./assets/imgs/overview/process-cn.png": 48872,
	"./assets/imgs/overview/process-en.png": 46466,
	"./assets/imgs/overview/project-cn.png": 60876,
	"./assets/imgs/overview/project-en.png": 94658,
	"./assets/imgs/overview/property-cn.png": 439,
	"./assets/imgs/overview/property-en.png": 792,
	"./assets/imgs/overview/skill-cn.png": 24624,
	"./assets/imgs/overview/skill-en.png": 34878,
	"./assets/imgs/overview/structure-cn.png": 17357,
	"./assets/imgs/overview/structure-en.png": 89832,
	"./assets/imgs/overview/tab-bg.png": 67064,
	"./assets/imgs/overview/title-cn.png": 61748,
	"./assets/imgs/overview/title-en.png": 29121,
	"./assets/imgs/results/ancs_benefit_phrase-cn.png": 85660,
	"./assets/imgs/results/ancs_benefit_phrase-en.png": 99921,
	"./assets/imgs/results/apd_y_benefit_phrase-cn.png": 15839,
	"./assets/imgs/results/apd_y_benefit_phrase-en.png": 48316,
	"./assets/imgs/results/apd_y_benefit_theme-cn.png": 95858,
	"./assets/imgs/results/apd_y_benefit_theme-en.png": 64033,
	"./assets/imgs/results/benefit_phrase_adc_c-cn.png": 23527,
	"./assets/imgs/results/benefit_phrase_adc_c-en.png": 58154,
	"./assets/imgs/results/benefit_theme_benefit_phrase-cn.png": 58126,
	"./assets/imgs/results/benefit_theme_benefit_phrase-en.png": 82941,
	"./assets/imgs/results/nodata-inline.png": 87940,
	"./assets/imgs/results/patent_property-cn.png": 1969,
	"./assets/imgs/results/patent_property-en.png": 19635,
	"./assets/imgs/results/patent_property_waveform-cn.png": 92692,
	"./assets/imgs/results/patent_property_waveform-en.png": 11644,
	"./assets/imgs/results/summary-bg.png": 63804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4597;